import type { Logger } from '@mimir/common/types/logger';

/**
 * Stages run strictly in sequence, so their durations sum to the total. A stage
 * that calls the bridge also includes waiting for the single ExtendScript engine,
 * which another bridge call may be holding.
 */
export class ScanTiming {
  private readonly stageMs: Record<string, number> = {};
  private readonly startedAt = Date.now();
  private stageStartedAt = Date.now();

  /** Attributes the time since the previous mark to `stage`; a repeated stage accumulates. */
  mark(stage: string): void {
    const now = Date.now();
    this.stageMs[stage] = (this.stageMs[stage] ?? 0) + (now - this.stageStartedAt);
    this.stageStartedAt = now;
  }

  report(logger: Logger, label: string, facts: Record<string, unknown>): void {
    const totalMs = Date.now() - this.startedAt;
    logger.debug(`cepPerformance ${label}\n${JSON.stringify({ totalMs, ...facts, stageMs: this.stageMs }, null, 2)}`);
  }
}
